import {
  type AddressCollection,
  addressCollectionSchema,
  type Address,
  addressSchema, addressFilterSchema, type AddressFilter,
} from '@/types/Wiser/address.ts'

import { createRestApi, type HttpClient, type ModelApi } from '@jantm/model-core'

export type AddressApi = ModelApi<Address, AddressCollection, AddressFilter>

/**
 * The HTTP client is injected rather than imported so this package never pins
 * an axios instance, a base URL, or an auth interceptor — the host application
 * owns all three.
 */
export function createAddressApi(
  client: HttpClient,
  endpoint = '/wiser/adres',
): AddressApi {
  return createRestApi({
    client,
    endpoint,
    schema: addressSchema,
    collectionSchema: addressCollectionSchema,
    filterSchema: addressFilterSchema,
  })
}
